module.exports = __webpack_public_path__ + "static/media/note.74cc2471.svg";